import { TableBodyCell, TeamAvatar } from '@pocketlaw/tetris';
import { StyledLink } from './styled';
export function NameCell(props) {
    const { teamId, name } = props;
    return (<TableBodyCell headers="name">
      <StyledLink to={`/users-teams/teams/${teamId}`}>
        <TeamAvatar size="sm" title={name}/>
      </StyledLink>
    </TableBodyCell>);
}
